import React from 'react';
import { Box, Typography } from '@mui/material';

const shortYear = (year) => {
  const text = String(year || '');
  return text.length >= 9 ? `${text.slice(2, 4)}-${text.slice(7, 9)}` : text;
};

/** Small yearly enrollment line with the peak year marked. */
const TrendSparkline = ({ series, color = '#1a4a8a', height = 90, ariaLabel }) => {
  const points = (series || []).filter((p) => Number.isFinite(Number(p.enrollment)));
  if (points.length < 2) {
    return (
      <Typography variant="caption" color="text.secondary">
        Not enough years of data to chart.
      </Typography>
    );
  }
  const width = 460;
  const pad = { top: 16, right: 12, bottom: 20, left: 12 };
  const values = points.map((p) => Number(p.enrollment));
  const max = Math.max(...values);
  const min = Math.min(...values, 0);
  const x = (i) => pad.left + (i * (width - pad.left - pad.right)) / (points.length - 1);
  const y = (v) => pad.top + (1 - (v - min) / (max - min || 1)) * (height - pad.top - pad.bottom);
  const peakIndex = values.lastIndexOf(max);
  const path = points.map((p, i) => `${i ? 'L' : 'M'}${x(i).toFixed(1)},${y(values[i]).toFixed(1)}`).join(' ');

  return (
    <Box component="svg" viewBox={`0 0 ${width} ${height}`} role="img" aria-label={ariaLabel} sx={{ width: '100%', height }}>
      <path d={path} fill="none" stroke={color} strokeWidth={2.5} />
      {points.map((p, i) => (
        <g key={p.year}>
          <circle cx={x(i)} cy={y(values[i])} r={i === peakIndex ? 5 : 3} fill={i === peakIndex ? '#cc2222' : color} />
          {(i === peakIndex || i === points.length - 1) && (
            <text x={x(i)} y={y(values[i]) - 8} textAnchor="middle" fontSize="11" fontWeight="700" fill="#333">
              {values[i].toLocaleString()}
              {i === peakIndex && i !== points.length - 1 ? ' peak' : ''}
            </text>
          )}
          <text x={x(i)} y={height - 4} textAnchor="middle" fontSize="10" fill="#888">
            {shortYear(p.year)}
          </text>
        </g>
      ))}
    </Box>
  );
};

export default TrendSparkline;
